var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-btn",attrs:{"id":"preview-btn"}},[_c('a-badge',{attrs:{"count":_vm.count,"offset":[-82, 0]}},[_c('div',{staticClass:"ant-btn-primary",on:{"click":_vm.preview}},[_c('span',[_vm._v("预览")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }